import ActionIconButton from '@/components/actions/actionIconButton';
import HeaderSearch from '@/components/headerSearch';
import HeaderUser from '@/components/headerUser';
import ReloadDialog from '@/components/reloadDialog';
import useAuth from '@/hooks/useAuth';
import { Group } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconReload } from '@tabler/icons-react';

export default function HeaderMenu() {
  const { canWrite } = useAuth();

  function openReloadDialog() {
    modals.open({
      title: (
        <Group>
          <IconReload /> Reload
        </Group>
      ),
      children: <ReloadDialog />,
      centered: true,
    });
  }

  return (
    <Group
      css={{
        margin: 'var(--mantine-spacing-sm)',
      }}
    >
      <HeaderSearch />

      {canWrite && (
        <ActionIconButton size={34} variant="default" onClick={openReloadDialog} title="Reload">
          <IconReload />
        </ActionIconButton>
      )}

      <HeaderUser />
    </Group>
  );
}
